export const ACCOUNT_APPROVAL_STATUS_CODE = {
  APPROVED: '1',
  REJECTED: '2',
  PENDING_APPROVED: '3',
  FINAL_APPROVED: '4',
  NEW_NOT_SUBMITTED: '5',
  PENDING_FINAL_APPROVE: '6',
  UNKNOWN: '0',
};

export const ACCOUNT_APPROVAL_STATUS_LABEL = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING_APPROVED: 'PendingApproved',
  PENDING_FINAL_APPROVE: 'PendingFinalApprove',
  FINAL_APPROVED: 'FinalApproved',
  NEW_NOT_SUBMITTED: 'NewNotSubmitted',
  UNKNOWN: 'Unknown',
};

export const ACCOUNT_APPROVAL_STATUS_MAP = [
  // APPROVED
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.APPROVED,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.APPROVED
  },
  // REJECTED
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.REJECTED,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.REJECTED
  },
  // PENDING_APPROVED
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.PENDING_APPROVED,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.PENDING_APPROVED
  },
  // PENDING_FINAL_APPROVE
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.PENDING_FINAL_APPROVE,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.PENDING_FINAL_APPROVE
  },
  // FINAL_APPROVED
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.FINAL_APPROVED,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.FINAL_APPROVED
  },
  // NEW_NOT_SUBMITTED
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.NEW_NOT_SUBMITTED,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.NEW_NOT_SUBMITTED
  },
  // UNKNOWN
  {
    code: ACCOUNT_APPROVAL_STATUS_CODE.UNKNOWN,
    label: ACCOUNT_APPROVAL_STATUS_LABEL.UNKNOWN
  },
];